// extracted by mini-css-extract-plugin
export default {"container":"Workout_container__jufOH","imgDiv":"Workout_imgDiv__J5vYr","img":"Workout_img__UtLnC","workoutName":"Workout_workoutName__l01zX"};